/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Creating_MixdownInputs */

const en_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating audio mixdown...`)
};

const fr_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du mixdown audio...`)
};

const de_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiomixdown wird erstellt...`)
};

const it_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione di un mixaggio audio...`)
};

const ru_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание аудиомикса...`)
};

const es_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando una mezcla de audio...`)
};

const zh_cn2_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行音频混音……`)
};

const ja_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオミックスダウンを作成しています...`)
};

const hi_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो मिक्सडाउन तैयार किया जा रहा है...`)
};

const pt_pt2_audio_description_export_status_creating_mixdown = /** @type {(inputs: Audio_Description_Export_Status_Creating_MixdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando a mixagem de áudio...`)
};

/**
* | output |
* | --- |
* | "Creating audio mixdown..." |
*
* @param {Audio_Description_Export_Status_Creating_MixdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_mixdown = /** @type {((inputs?: Audio_Description_Export_Status_Creating_MixdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_MixdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "de") return de_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "it") return it_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "ru") return ru_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "es") return es_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "ja") return ja_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "hi") return hi_audio_description_export_status_creating_mixdown(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_creating_mixdown(inputs)
	return en_audio_description_export_status_creating_mixdown(inputs)
});